export const initialslowmovingproducts = {
  productCode: "",
  productCategory: "",
  brand: "",
  productName: "",
  slowMovingFor : "",
  customer :"",
  ageOfStock: "",
  reasonForSlowMovement: "",

  productCategoryStatus: "unchecked",
  brandStatus: "unchecked",
  productNameStatus: "unchecked",
  slowMovingForStatus:"unchecked",
  customerStatus:"unchecked",
  ageOfStockStatus: "unchecked",
  reasonForSlowMovementStatus: "unchecked",
  productCodeStatus: "unchecked",
};

export const slowmovingproductsreducer = (state, action) => {
  console.log(state,action,"state");
  
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "productCode": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productCode: value,
          productCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCode: "",
          productCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productCode: value,
          productCodeStatus: "error",
        };
      }
    }
    case "productName": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productName: value,
          productNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productName: "",
          productNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productName: value,
          productNameStatus: "error",
        };
      }
    }
    case "brand": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          brand: value,
          brandStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          brand: "",
          brandStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          brand: value,
          brandStatus: "error",
        };
      }
    }
    case "productCategory": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCategory: "",
          productCategoryStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "error",
        };
      }
    }

    case "slowMovingFor":
      return{
        ...state,
        slowMovingFor:value,
        slowMovingForStatus:value ? "success" : "unchecked",
      };

      case "customer" :
        return{
          ...state,
          customer:value,
          customerStatus:value ? "success" : "unchecked",
        };

    case "ageOfStock": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          ageOfStock: value,
          ageOfStockStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          ageOfStock: "",
          ageOfStockStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          ageOfStock: value,
          ageOfStockStatus: "error",
        };
      }
    }

    case "reasonForSlowMovement": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          reasonForSlowMovement: value,
          reasonForSlowMovementStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          reasonForSlowMovement: "",
          reasonForSlowMovementStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          reasonForSlowMovement: value,
          reasonForSlowMovementStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};
